import "@fontsource/poppins";
import "@fontsource/poppins/400.css"; // Regular
import "@fontsource/poppins/500.css"; // Medium
import "@fontsource/poppins/700.css"; // Bold
import { RecaptchaVerifier } from "firebase/auth";
import LogRocket from 'logrocket';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./App.css";
import { ApiProvider } from "./contexts/ApiContext";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./pages/auth/Login";
import MultiFactor from "./pages/auth/MultiFactor";
import CasesRouter from "./pages/cases/Router";
import Profile from "./pages/user/Profile";
import Welcome from "./pages/welcome/Welcome";
import { MfaRoute, PrivateRoute, PublicRoute } from "./RouteGuards";
import { AppProvider } from "./contexts/AppContext";

declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier;
  }
}
LogRocket.init('xclgms/canotera');

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <ApiProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/auth/login" replace />} />
              <Route element={<PublicRoute />}>
                <Route path="/auth/login" element={<Login />} />
              </Route>
              <Route element={<MfaRoute />}>
                <Route path="/auth/mfa" element={<MultiFactor />} />
              </Route>
              <Route element={<PrivateRoute />}>
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/user" element={<Profile />} />
                <Route path="/cases/*" element={<CasesRouter />} />
              </Route>
            </Routes>
          </Router>

          <div id="recaptcha-container"></div>
        </ApiProvider>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
